// LiveKit session-report timestamps are intentionally asymmetric. In agents-js
// 1.7+, only `chat_history.items[].created_at` is converted from Unix
// milliseconds to Unix seconds during serialization; `events[].created_at`
// remains in milliseconds. Message `metrics.startedSpeakingAt` is also emitted
// in seconds. Apply this helper only to the two second-or-millisecond fields,
// never to session-event timestamps.
const UNIX_SECONDS_UPPER_BOUND = 10_000_000_000;

export function normalizeLivekitTimestampMs(value: unknown): number | null {
  if (typeof value !== "number" || !Number.isFinite(value) || value < 0) {
    return null;
  }

  return value < UNIX_SECONDS_UPPER_BOUND ? value * 1000 : value;
}
